export default {
  howItWorksPage: {
    seoTitle: 'كيف يعمل Geofleet — من الطلب إلى إثبات التسليم | Geofleet',
    seoDescription:
      'تعرّف على طريقة عمل Geofleet في ست خطوات: استيراد الطلبات، وتخطيط مسارات محسّنة، وإرسالها إلى تطبيق السائق، والتتبع المباشر، وإرسال رابط تتبع للعملاء، وتسجيل إثبات التسليم — كل ذلك من مركز قيادة واحد مع Copilot مدعوم بالذكاء الاصطناعي.',
    heroBadge: 'كيف يعمل',
    heroTitle: 'كيف يعمل Geofleet:',
    heroTitleHighlight: 'يدخل الطلب، ويخرج إثبات التسليم',
    /** Direct answer paragraph — written to be quotable by search and AI answer engines. */
    heroLead:
      'Geofleet برنامج لإدارة عمليات التوصيل. تُدخل الطلبات من ملف CSV أو متجرك أو عبر API. يخطط Geofleet مسارات محسّنة ويرسلها إلى هواتف السائقين. بعد ذلك تتابع كل محطة مباشرة، وترسل للعملاء رابط تتبع برسالة نصية، وتجمع إثبات التسليم بالصورة أو التوقيع أو OTP. كل ذلك يعمل من مركز قيادة واحد، ويجيب Copilot المدعوم بالذكاء الاصطناعي عن الأسئلة حول البيانات المباشرة نفسها.',
    heroFacts: [
      { icon: 'ri-price-tag-3-line', label: 'من $49 شهرياً لـ3 سائقين' },
      { icon: 'ri-smartphone-line', label: 'تطبيق السائق يعمل دون اتصال' },
      { icon: 'ri-link', label: 'لا حاجة لتثبيت تطبيق لدى العملاء' },
    ],
    stepsKicker: 'دورة التوصيل',
    stepsTitle: 'ست خطوات من الطلب إلى إثبات التسليم',
    stepsIntro: 'يمر كل طلب بالخطوات الست نفسها في Geofleet، سواء كان لديك 5 سائقين أو 500.',
    stepLabel: 'الخطوة {{n}}',
    steps: [
      {
        title: 'أدخل طلباتك',
        body: 'ارفع ملف CSV أو جدول بيانات، أو زامن الطلبات تلقائياً من Shopify ومنصات OMS الأخرى، أو أرسلها عبر API أو MCP، أو أضفها يدوياً. تُحوَّل العناوين إلى إحداثيات عند الاستيراد لتكون جاهزة لتخطيط المسارات.',
        points: ['قوالب CSV وجداول البيانات', 'Shopify وUnicommerce وأكثر من 10 تكاملات OMS', 'REST API وMCP لأنظمتك الخاصة'],
        linkLabel: 'عرض التكاملات',
        linkHref: '/integrations',
        imageAlt: 'رفع ملف CSV لطلبات التوصيل إلى Geofleet',
      },
      {
        title: 'خطط مسارات محسّنة',
        body: 'اختر ملف تخطيط، مثل «توصيلات الغد»، وأنشئ خطة ذكية. يراعي محرك المسارات النوافذ الزمنية وسعة المركبات وحركة المرور وعبء عمل السائقين، ثم يجمع المحطات في رحلات.',
        points: ['النوافذ الزمنية وحدود المناوبات', 'السعة حسب الوزن والحجم وعدد القطع', 'توزيع متوازن للعمل بين السائقين'],
        linkLabel: 'مخطط المسارات',
        linkHref: '/features/route-planner',
        imageAlt: 'التخطيط الذكي في Geofleet ينشئ مسارات محسّنة من ملف تخطيط',
      },
      {
        title: 'أرسل إلى السائقين',
        body: 'راجع المسافة والمدة وعدد الطلبات لكل رحلة، ثم انشرها. يصل المسار إلى تطبيق السائق مع ملاحة خطوة بخطوة. في خطة Premium، يتولى الإرسال والتوزيع التلقائيان بالذكاء الاصطناعي تعيين الرحلات نيابةً عنك.',
        points: ['نشر بنقرة واحدة إلى تطبيق السائق', 'يعمل دون اتصال ويتزامن عند عودة الاتصال', 'إرسال تلقائي بالذكاء الاصطناعي في Premium'],
        linkLabel: 'تطبيق السائق',
        linkHref: '/features/driver-app',
        imageAlt: 'رحلة منشورة يتم إرسالها إلى سائق في Geofleet',
      },
      {
        title: 'تتبّع مباشرة وعدّل',
        body: 'كل مركبة وكل محطة على خريطة مباشرة واحدة. تنتقل المحطات المتأخرة أو المعرّضة للتأخير إلى أعلى القائمة. يمكنك إعادة ترتيب المحطات أو إعادة تعيين الطلبات أو إضافة محطة أثناء المسار، ويتحدّث تطبيق السائق فوراً.',
        points: ['خريطة مباشرة تقارن المسار المخطط بالفعلي', 'الاستثناءات ومخاطر SLA تظهر أولاً', 'إعادة الترتيب بالسحب والإفلات'],
        linkLabel: 'التقارير والتحليلات',
        linkHref: '/features/reports-analytics',
        imageAlt: 'إعادة ترتيب طلبات التوصيل على خريطة مسار مباشرة في Geofleet',
      },
      {
        title: 'أبقِ العملاء على اطلاع',
        body: 'يتلقى العملاء رابط تتبع عبر SMS أو البريد الإلكتروني أو WhatsApp. يفتح في أي متصفح ويعرض الحالة المباشرة ووقت الوصول المتوقع وموقع السائق على الخريطة، دون الحاجة إلى تثبيت أي شيء. في خطة Premium، تحمل الصفحة علامتك التجارية.',
        points: ['تحديثات تلقائية عند المراحل الرئيسية', 'وقت وصول مباشر والتواصل مع السائق', 'صفحة تتبع بعلامتك التجارية في Premium'],
        linkLabel: 'تتبع بعلامتك التجارية',
        linkHref: '/features/branded-tracking',
        imageAlt: 'عميل يتابع توصيلاً مباشراً عبر رابط تتبع من Geofleet على هاتفه',
      },
      {
        title: 'أثبت التسليم وقِس الأداء',
        body: 'يسجّل السائقون صورة أو توقيعاً إلكترونياً أو OTP أو مسحاً للباركود عند الباب. يحمل كل إثبات ختماً زمنياً وموقعاً جغرافياً. تغذي النتائج معدل الالتزام بالموعد وتكلفة كل توصيلة وبطاقات أداء السائقين، لتعرف ما يجب تحسينه غداً.',
        points: ['الصورة والتوقيع وOTP والباركود', 'سجلات إثبات قابلة للبحث والتصدير', 'مؤشرات الالتزام بالموعد وتكلفة التوصيلة وأداء السائقين'],
        linkLabel: 'إثبات التسليم',
        linkHref: '/features/proof-of-delivery',
        imageAlt: 'سائق يلتقط صورة كإثبات للتسليم في تطبيق السائق من Geofleet',
      },
    ],
    surfacesKicker: 'أين تدير العمل',
    surfacesTitle: 'مركز قيادة واحد، مع Copilot مدمج',
    surfacesIntro:
      'تتم الخطوات الست كلها في مكان واحد. مركز القيادة هو العرض المباشر لعملياتك. وCopilot مساعد ذكاء اصطناعي يقرأ البيانات نفسها ويمكنه التصرف بناءً عليها ضمن صلاحياتك.',
    towerSectionTitle: 'مركز القيادة',
    towerLead: 'الطلبات والسائقون والخريطة المباشرة وأوقات الوصول والاستثناءات على شاشة واحدة، ليكون الإجراء التالي واضحاً.',
    towerFeatureCards: [
      {
        title: 'أدخل بياناتك بطريقتك',
        description: 'التكاملات أو MCP أو قوالب CSV أو الإدخال اليدوي، وكلها تصل إلى قائمة الطلبات نفسها.',
      },
      {
        title: 'خطط وعيّن وتكيّف',
        description: 'أعد التعيين وأعد الترتيب وأدرج محطات ونفّذ تحديثات جماعية ضمن ضوابط الأدوار والسياسات.',
      },
      {
        title: 'خريطة واحدة وقوائم ذات أولوية',
        description: 'تظهر الاستثناءات في المقدمة، ويرى كل دور ما يخصه: الإرسال أو قادة المراكز أو الشركاء.',
      },
      {
        title: 'قِس ودقّق',
        description: 'معدل الالتزام بالموعد وتكلفة كل توصيلة وبطاقات الأداء، مع سجل كامل لمن غيّر ماذا ومتى.',
      },
    ],
    copilotSectionTitle: 'Copilot',
    copilotLead: 'اسأل عن عملياتك بلغة بسيطة. تأتي الإجابات من البيانات المباشرة، لا من نص عام مولَّد بالذكاء الاصطناعي.',
    copilotFeatureCards: [
      {
        title: 'اسأل بلغة بسيطة',
        description: '«ما المحطات المتأخرة في المنطقة الشمالية؟» أو «ما الذي تغيّر منذ 09:00؟»',
      },
      {
        title: 'إجابات تشغيلية',
        description: 'قوائم مفلترة ومقارنات وملخصات للإرسال والمسارات والاستثناءات.',
      },
      {
        title: 'إجراءات مقترحة ضمن ضوابط',
        description: 'يقترح Copilot إعادة توجيه أو تحديثات جماعية لتؤكدها بنفسك. ولا يمكنه تنفيذ ما لا يسمح به دورك.',
      },
      {
        title: 'إعداد أسرع',
        description: 'توجيهات إرشادية لإعداد المراكز والتكاملات وسير العمل دون عناء التنقل بين جداول البيانات.',
      },
    ],
    faqKicker: 'الأسئلة الشائعة',
    faqTitle: 'أسئلة حول طريقة عمل Geofleet',
    faqs: [
      {
        question: 'كيف يعمل Geofleet؟',
        answer:
          'يستقبل Geofleet طلبات التوصيل من ملف CSV أو متجرك أو عبر API، ويخطط مسارات محسّنة. ثم يرسل هذه المسارات إلى تطبيق السائق، ويتتبع كل محطة مباشرة، ويرسل للعملاء رابط تتبع. عند الباب، يسجّل السائقون إثبات التسليم بالصورة أو التوقيع أو OTP. ويدير المرسِلون كل شيء من مركز قيادة واحد، مع Copilot مدعوم بالذكاء الاصطناعي للأسئلة والإجراءات الجماعية.',
      },
      {
        question: 'كيف أُدخل طلباتي إلى Geofleet؟',
        answer:
          'هناك أربع طرق. يمكنك رفع ملف CSV أو جدول بيانات، أو ربط نظام OMS أو متجر مثل Shopify أو Unicommerce لمزامنة الطلبات تلقائياً، أو إرسال الطلبات عبر REST API أو MCP، أو إضافتها يدوياً. ويمكنك الجمع بين الطرق: كثير من الفرق تبدأ بملف CSV ثم تضيف تكاملاً لاحقاً.',
      },
      {
        question: 'هل يحتاج السائقون إلى تثبيت تطبيق؟',
        answer:
          'نعم. يستخدم السائقون تطبيق السائق من Geofleet لاستلام المسارات والملاحة وتسجيل إثبات التسليم وتسجيل الحضور. يعمل التطبيق دون اتصال ويتزامن عند عودة اتصال الهاتف.',
      },
      {
        question: 'هل يحتاج العملاء إلى تثبيت أي شيء لتتبع التوصيل؟',
        answer:
          'لا. يتلقى العملاء رابط تتبع عبر SMS أو البريد الإلكتروني أو WhatsApp يفتح في أي متصفح. ويعرض الحالة المباشرة ووقت الوصول المتوقع وموقع السائق.',
      },
      {
        question: 'هل يمكن لـ Copilot تغيير الطلبات أو المسارات من تلقاء نفسه؟',
        answer:
          'فقط ضمن الصلاحيات التي تحددها. يلتزم Copilot بالتحكم في الوصول حسب الدور، فلا يمكنه إلا تنفيذ ما يُسمح للمستخدم المسجّل بفعله. ويقترح إجراءات مثل إعادة التوجيه أو التحديثات الجماعية لتؤكدها بنفسك.',
      },
      {
        question: 'كم تكلفة تجربة Geofleet؟',
        answer:
          'تبدأ الخطط مع Geofleet Lite بسعر $49 شهرياً لـ3 سائقين و2,000 طلب، ثم $10 لكل سائق إضافي. تبلغ تكلفة Professional $19 وPremium $29 لكل سائق شهرياً، مع فوترة ربع سنوية. وتتضمن Professional فترة تجربة مجانية مدتها 14 يوماً.',
      },
    ],
    visualHeroAlt: 'مركز قيادة Geofleet مع خريطة مباشرة ومؤشرات أداء وقائمة طلبات',
    visualCommandAlt: 'مركز قيادة Geofleet — الخريطة المباشرة والعرض التشغيلي',
    visualCopilotAlt: 'Copilot من Geofleet يجيب عن سؤال إرسال بجانب مسار مباشر',
    closingTitle: 'شاهد طلباتك الفعلية تمر عبر النظام',
    closingSub: 'ابدأ بملف CSV لطلبات حقيقية، أو احجز عرضاً توضيحياً وسنستعرض معك سير عملك.',
  },
};
